// extracted by mini-css-extract-plugin
export var lg = "_48-4";
export var md = "_48-3";
export var sm = "_48-2";
export var xs = "_48-1";
export var xxs = "_48-0";